import { BaseFileFiledDto } from '@diritto/common/base/base.dto';
import { ImageTransformOptions, ImageTransformType } from '@diritto/common/imageKit/constants';
import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ZIndex } from 'constants/zIndex';
import { Loading } from 'ui-components/common/Loading';
import { IkImage } from 'ui-components/Imagekit/IkImage';
import { configure } from 'utils/configure';

interface PartnerProfileImageProps {
  className?: string;
  file?: BaseFileFiledDto;
  size?: number;
  transform?: boolean;
  isLoading?: boolean;
}

export const PartnerProfileImage = ({
  file,
  className,
  size = 30,
  transform = true,
  isLoading = false,
}: PartnerProfileImageProps) => {
  if (isLoading) {
    return (
      <StyledProfileLoadingWrapper className={className} size={size}>
        <Loading />
      </StyledProfileLoadingWrapper>
    );
  }

  return (
    <div className={className}>
      <StyledProfileImageWrapper size={size}>
        {file ? (
          <IkImage
            transform={{
              path: file.path,
              isPrivate: file.isPrivate,
              transformation: transform
                ? ImageTransformOptions[ImageTransformType.Profile]
                : ImageTransformOptions[ImageTransformType.Original],
            }}
            alt="ProfileImage"
          />
        ) : (
          <img
            src={`${configure.staticPrefix}/images/partner/default-profile.svg`}
            alt="Contents Partners"
            className={`w-[${size}px]`}
          />
        )}
      </StyledProfileImageWrapper>
    </div>
  );
};

const StyledProfileLoadingWrapper = styled.div(
  ({ size }: { size: number }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${size}px;
    height: ${size}px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  `,
);

const StyledProfileImageWrapper = styled.div(
  ({ size }: { size: number }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${size}px;
    height: ${size}px;
    border-radius: 50%;
    background-color: ${Color.White};
    position: relative;

    &::before {
      content: '';
      position: absolute;
      border-radius: 50%;
      z-index: ${ZIndex.ProfileImageBorder};
      width: ${size}px;
      height: ${size}px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    }

    & img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    & svg {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  `,
);
